import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/lib/auth";
import PublicLayout from "@/components/site/PublicLayout";
import AdminLayout from "@/components/site/AdminLayout";
import ProtectedRoute from "@/components/site/ProtectedRoute";

import Home from "@/pages/Home";
import BidangDetail from "@/pages/BidangDetail";
import Berita from "@/pages/Berita";
import BeritaDetail from "@/pages/BeritaDetail";
import Regulasi from "@/pages/Regulasi";
import Galeri from "@/pages/Galeri";
import Agenda from "@/pages/Agenda";
import Statistik from "@/pages/Statistik";
import BrandGuideline from "@/pages/BrandGuideline";
import Kontak from "@/pages/Kontak";

import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminKontak from "@/pages/AdminKontak";
import { AdminBerita, AdminRegulasi, AdminGaleri, AdminAgenda } from "@/pages/AdminResources";

function App() {
  return (
    <div className="App font-body">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/bidang/:slug" element={<BidangDetail />} />
              <Route path="/informasi/berita" element={<Berita />} />
              <Route path="/informasi/berita/:slug" element={<BeritaDetail />} />
              <Route path="/informasi/regulasi" element={<Regulasi />} />
              <Route path="/informasi/galeri" element={<Galeri />} />
              <Route path="/informasi/agenda" element={<Agenda />} />
              <Route path="/statistik" element={<Statistik />} />
              <Route path="/statistik/:kode" element={<Statistik />} />
              <Route path="/brand" element={<BrandGuideline />} />
              <Route path="/kontak" element={<Kontak />} />
            </Route>

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
              <Route index element={<AdminDashboard />} />
              <Route path="berita" element={<AdminBerita />} />
              <Route path="regulasi" element={<AdminRegulasi />} />
              <Route path="galeri" element={<AdminGaleri />} />
              <Route path="agenda" element={<AdminAgenda />} />
              <Route path="kontak" element={<AdminKontak />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
